<template>
  <div class="flex-none w-56" aria-hidden="true">
    <!-- Spacer to align with the date marker on filled cards. -->
    <p class="h-4 mb-2"></p>
    <div
      class="w-full aspect-video rounded-lg border border-primary-400 bg-primary-500/20"
    ></div>
  </div>
</template>

<script>
export default {
  name: "EmptyUpcomingCard",
};
</script>
